import { render, staticRenderFns } from "./paxdriveeditdialog.vue?vue&type=template&id=27856f45&"
import script from "./paxdriveeditdialog.vue?vue&type=script&lang=js&"
export * from "./paxdriveeditdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports